import React from 'react';
import { Feature, IActionPointInfo } from '@tencent/workbench';
import BaseToolbarFeature from '@src/framework/workbench/common/feature/base-toolbar-feature';
import type { IBatchHandleAnimationFeature } from './batch-handle-animation-interface';
import { config } from './config';
import BatchHandleAnimation from './index';

@Feature()
export class BatchHandleAnimationFeature extends BaseToolbarFeature implements IBatchHandleAnimationFeature {
    public id = config.id;
    public config = config;
    public constructor() {
        super();
    }

    public getBatchHandleAnimation(batchAnimationInfo: IActionPointInfo) {
        return <BatchHandleAnimation
            batchAnimationInfo={batchAnimationInfo}
            getAnimationEditorService={this.getBatchHandleAnimationService}
            slideDataList = {this.getSlideDataList()}
            selectedModel = {this.getSelectedModel()}
            selectedSlideList = {this.getSelectedSlideList()}
            currentSlide = {this.getCurrentSlide()}
            getEditorAnimPreviewManager ={this.getEditorAnimPreviewManager}
            slideModelList = {this.getSlideModelList()}
            currentSlideIndex = {this.getCurrentSlideIndex()}
        />;
    }
    private getBatchHandleAnimationService = () => this.getAppService().editableServiceLayer?.animationEditorService;
    private getSlideDataList = () => this.getAppService().getUiDataService().presentation.sdkData?.slideList;
    private getSelectedModel = () => this.getAppService().viewableServiceLayer.selectionService.getSelectedModel();
    private getSelectedSlideList  = () => this.getAppService().viewableServiceLayer.selectionService.selectedSlides
        .selectedArray;
    private getCurrentSlide = () => this.getAppService().viewableServiceLayer.selectionService.currentSlide;
    private getEditorAnimPreviewManager = () => this.getAppService().viewableServiceLayer
        ?.getEditorAnimPreviewManager();
    private getSlideModelList = () => this.getAppService().getUiDataService().slideModelList;
    private getCurrentSlideIndex = () => this.getAppService().viewableServiceLayer.selectionService.currentSlideIndex;
}
